module.exports = __webpack_public_path__ + "img/logo_lexus.844ef73a.png";